import { Inject, Injectable } from '@angular/core';
import { CommonsSessionStorageService, downgradeToAJSService } from 'ib-web-commons/utils';
import { PrefixResponse } from './models/ib-prefix-model';
import { AJSCommonsGenericProxyService, AJSCommonsGenericProxyServiceType, AJSCommonsNewHttpUtilsErrorService, AJSIbCHttpErrorHandlerServiceType } from '@src/components/services/http/commons-proxy-bridge.service';
import { MmBAppConstants } from '@src/ib-MmB-constants';

@Injectable({
    providedIn :'root'
})

export class IbMmBGetPhoneCodeService {
    constructor (
        @Inject(AJSCommonsGenericProxyService) private CommonsGenericProxyService: AJSCommonsGenericProxyServiceType,
        @Inject(AJSCommonsNewHttpUtilsErrorService) private CommonsNewHttpUtilsErrorService: AJSIbCHttpErrorHandlerServiceType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
    ) { }

    getPhoneCodesList = (): Promise<PrefixResponse[]> => {
        return new Promise((resolve, reject)=>{
            const phoneCodeList = this.CommonsSessionStorageService.get<PrefixResponse[]>('phoneCodeList');

            const getPhoneCodesListSuccess = (phoneCodeList: any): void => {
                this.CommonsSessionStorageService.set('phoneCodeList', phoneCodeList.data);
                resolve(phoneCodeList.data);
            };

            const getPhoneCodesListError = (error:unknown): void => {
                this.CommonsNewHttpUtilsErrorService.handlePromiseError(error, reject);
            };

            if (phoneCodeList === null) {
                const endpoint = MmBAppConstants.DEFAULT_ENDPOINTS.phoneCodesURI;
                const config: any = {
                    headers: {
                        'Cache-Control': 'private, max-age=600'
                    }
                };
                this.CommonsGenericProxyService.getGeneric(endpoint, config).then(getPhoneCodesListSuccess, getPhoneCodesListError);
            } else {
                resolve(phoneCodeList);
            }

        });
    };
}

downgradeToAJSService('IbMmBGetPhoneCodeService', IbMmBGetPhoneCodeService, 'ib-MmB-services-module');
